"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CompanyOnboardingNotice;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Card_1 = __importDefault(require("../components/Card"));
const react_i18next_1 = require("react-i18next");
const react_native_1 = require("react-native");
const UserContext_1 = require("../contexts/UserContext");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const MainMenuItem_1 = __importDefault(require("../components/MainMenuItem"));
const Loading_1 = __importDefault(require("../components/Loading"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function CompanyOnboardingNotice(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const working = (userContext.initializing ||
        userContext.employeeLoading ||
        userContext.clientLoading);
    const gotoOnboarding = async () => {
        props.navigation.navigate("CompanyOnboarding");
    };
    return ((0, jsx_runtime_1.jsx)(Card_1.default, { style: { paddingHorizontal: size != 'sm' ? 24 : 8, paddingVertical: size != 'sm' ? 24 : 12 }, children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                        flexDirection: 'row',
                        marginVertical: 8,
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        gap: 8
                    }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                color: THEME.Text, fontSize: (size != 'sm' ? 32 : 26),
                                fontWeight: '500', marginTop: -8, textAlign: 'center'
                            }, children: t('register:headers.welcome') }), (0, jsx_runtime_1.jsx)(Theme_1.NextepLogo, { height: size != 'sm' ? 40 : 30, width: size != 'sm' ? 160 : 100 })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { margin: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: (size != 'sm' ? 16 : 14), fontWeight: '400' }, children: t('register:text.companyOnboardInfo') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                        marginVertical: 12,
                        marginHorizontal: 12
                    }, children: working
                        &&
                            (0, jsx_runtime_1.jsx)(Loading_1.default, { loading: working, retryable: false })
                        ||
                            (0, jsx_runtime_1.jsx)(MainMenuItem_1.default, { disabled: working, icon: Theme_1.ICONS.Solid.Building, text: t('register:buttons.companyOnboarding'), actionText: t('register:buttons.start'), onPress: gotoOnboarding }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { margin: 12, marginBottom: size == 'sm' || size == 'md' ? 8 : 0 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: (size != 'sm' ? 16 : 14), fontWeight: '400' }, children: t('register:text.onboardAfter') }) })] }) }));
}
